<template>
  <!-- Features Section Start -->
  <section id="forms" class="section-padding">
    <div class="container">
      <div class="section-header text-center">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">جدول کلی دروس دکترا و کارشناسی ارشد 3 گرایش و
          نسخه شناسی ورودی 1400</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="content-left">
            <div class="box-item wow fadeInLeft" data-wow-delay="0.3s">
              <div class="text d-flex">
                <span class="icon">
                  <i class="lni-leaf" style="font-size: 3rem;"></i>
                </span>
                <ul>
                  <li>
                    <i class="lni lni-more-alt text-green "></i>
                    <a href="/doc/3trends.pdf">
                       جدول دروس سه گرایش عمومی ، تاریخ ، فرهنگ مردم و آداب و رسوم و میراث فرهنگی ایران شناسی
                    </a>
                  </li>
                  <li>
                    <i class="lni lni-more-alt text-green "></i>
                    <a href="/doc/CognitiveCourses.pdf">
                      جدول دروس گرایش  اصول نسخه شناسی و مرمت نسخه های خطی و نسخه آرایی ایران شناسی
                    </a>
                  </li>
                  <li>
                    <i class="lni lni-more-alt text-green "></i>
                    <a href="/doc/PhDCourses.pdf">
                      جدول دروس دوره دكتری ايران شناسی
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Features Section End -->

</template>
<script>
import {master, doctor, common} from "../Data/formData";

export default {
  name: "Forms",
  data() {
    return {
      masters: master,
      doctors: doctor,
      commons: common,
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/color";

ul li {
  //list-style: disc !important;
  margin-bottom: 5px;
  text-align: right;
}

ul li a {
  color: $green;
  padding-bottom: 10px;
  padding-right: 10px;
  position: relative;
  top: -3px;
}

h3 {
  font-size: 1.5rem;
}

.mrBoxShadowNun {
  box-shadow: none !important;
}
</style>